import React, { Component } from 'react';
import PropTypes from 'prop-types';

import intlShape from '@/shared/utils/intlShape';
import { CanRead } from '@/shared/components/security';
import DocumentService from '@/shared/services/DocumentService';
import messages from './registrationMessages';
import { uploadTempAttachments, deleteTempAttachment } from './resourceApi';

const attachmentName = attachment =>
  attachment.name || attachment.fileName || attachment.originalFileName || attachment.title || '';

/**
 * Add/list/remove attachments on the communication report. Files are uploaded as temporary
 * documents and linked to the interaction on save (see `linkInteractionAttachments`).
 */
class InteractionAttachments extends Component {
  state = { uploading: false };

  onFilesSelected = e => {
    const files = Array.from(e.target.files || []);
    e.target.value = '';
    if (!files.length) return;
    const { attachments, onChange } = this.props;
    this.setState({ uploading: true });
    uploadTempAttachments(files)
      .then(docs => onChange([...(attachments || []), ...docs]))
      .finally(() => this.setState({ uploading: false }));
  };

  onDelete = attachment => {
    const { attachments, onChange } = this.props;
    deleteTempAttachment(attachment.documentId || attachment.id).then(() =>
      onChange((attachments || []).filter(a => a !== attachment)),
    );
  };

  onDownload = attachment => DocumentService.download(attachment.documentId || attachment.id);

  render() {
    const { attachments, disabled, intl } = this.props;
    const { uploading } = this.state;
    const list = attachments || [];

    return (
      <>
        <label
          className={`btn btn-default btn-xs${disabled ? ' disabled' : ''}`}
          htmlFor="GroupAttachmentInput"
        >
          {uploading ? (
            <i className="fa fa-spinner fa-spin margin5R" />
          ) : (
            <i className="fa fa-paperclip margin5R" />
          )}
          <span>{intl.formatMessage(messages.AddAttachment)}</span>
          <input
            id="GroupAttachmentInput"
            type="file"
            multiple
            className="hidden"
            disabled={disabled || uploading}
            onChange={this.onFilesSelected}
          />
        </label>

        {list.length > 0 && (
          <CanRead on="Documents">
            <div className="margin5T">
              {list.map(attachment => (
                <div
                  key={attachment.documentId || attachment.id}
                  className="inline-attachment text-nowrap"
                >
                  <a
                    onClick={() => this.onDownload(attachment)}
                    title={intl.formatMessage(messages.DownloadAttachment)}
                  >
                    <i className="fa fa-file-o margin5R" />
                    <span>{attachmentName(attachment)}</span>
                  </a>
                  {!disabled && (
                    <i
                      className="fa fa-times clickable margin5L"
                      title={intl.formatMessage(messages.DeleteAttachment)}
                      onClick={() => this.onDelete(attachment)}
                    />
                  )}
                </div>
              ))}
            </div>
          </CanRead>
        )}
      </>
    );
  }
}

InteractionAttachments.propTypes = {
  attachments: PropTypes.arrayOf(PropTypes.shape({})),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  intl: intlShape.isRequired,
};

InteractionAttachments.defaultProps = {
  attachments: [],
  disabled: false,
};

export default InteractionAttachments;
